"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformResponseToRefreshStatus = exports.transformActionParamsToRequestData = exports.transformMfaResponseToMfaChallenge = exports.transformRefreshingLoginsToRequestData = exports.transformInstitutionLoginToRequestData = exports.transformResponseToInstitutionLogins = exports.transformQcsInstitutionLoginsToInstitutionLogins = exports.transformQcsInstitutionLoginToInstitutionLogin = void 0;
const immutable_1 = require("immutable");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const types = __importStar(require("data/institutionLogins/types"));
const transformOptionalAction = (qLogin) => {
    var _a, _b;
    if (qLogin.optionalAction === 'FI_MIGRATION' && qLogin.channel === ((_b = (_a = qLogin.fiMigrationInfo) === null || _a === void 0 ? void 0 : _a.toFI) === null || _b === void 0 ? void 0 : _b.channel)) {
        return undefined;
    }
    return qLogin.optionalAction;
};
const transformQcsInstitutionLoginToInstitutionLogin = (qLogin) => {
    let aggregators = null;
    if (qLogin.aggregators) {
        const connectedAggregators = qLogin.aggregators
            .filter((aggregator) => aggregator.cpId != null)
            .map((aggregator) => types.mkInstitutionLoginAggregator({
            channel: aggregator.cpChannel || 'FDP_DEFAULT',
            cpId: aggregator.cpId,
            aggStatus: aggregator.aggStatus,
            aggStatusCode: aggregator.aggStatusCode,
            aggStatusDetail: aggregator.aggStatusDetail,
            lastStatusUpdatedAt: aggregator.lastStatusUpdatedAt,
            lastRefreshAttemptedAt: aggregator.lastRefreshAttemptedAt,
            lastRefreshSuccessfulAt: aggregator.lastRefreshSuccessfulAt,
        }));
        if (connectedAggregators.length > 0) {
            aggregators = (0, immutable_1.List)(connectedAggregators);
        }
    }
    return types.mkInstitutionLogin({
        id: qLogin.id,
        name: qLogin.name,
        isDeleted: qLogin.isDeleted,
        institutionId: qLogin.institutionId,
        brandingId: qLogin.brandingId,
        cpInstitutionId: qLogin.cpInstitutionId,
        channel: qLogin.channel,
        optionalAction: transformOptionalAction(qLogin),
        fiMigrationInfo: qLogin.fiMigrationInfo
            ? types.mkFiMigrationInfo({
                toInstitutionId: qLogin.fiMigrationInfo.toFI.institutionId,
                toChannel: qLogin.fiMigrationInfo.toFI.channel,
            })
            : undefined,
        // TODO: this belongs on QCS, shouldn't be hardcoded here!
        ewcLive: false,
        aggregators,
    });
};
exports.transformQcsInstitutionLoginToInstitutionLogin = transformQcsInstitutionLoginToInstitutionLogin;
const transformQcsInstitutionLoginsToInstitutionLogins = (qLogins) => qLogins.map(exports.transformQcsInstitutionLoginToInstitutionLogin);
exports.transformQcsInstitutionLoginsToInstitutionLogins = transformQcsInstitutionLoginsToInstitutionLogins;
const transformResponseToInstitutionLogins = (response) => (0, exports.transformQcsInstitutionLoginsToInstitutionLogins)(response.data.resources);
exports.transformResponseToInstitutionLogins = transformResponseToInstitutionLogins;
const transformInstitutionLoginToRequestData = (institutionLogin) => {
    var _a, _b, _c;
    return ({
        id: institutionLogin.id ? institutionLogin.id : null,
        cpSetupMode: 'SKIP_ACCOUNT_DISCOVERY',
        channel: institutionLogin.channel,
        name: institutionLogin.name ? institutionLogin.name : null,
        aggregators: !institutionLogin.aggregators || institutionLogin.aggregators.size === 0 ? null :
            [{
                    cpChannel: (_a = institutionLogin.aggregators.get(0)) === null || _a === void 0 ? void 0 : _a.channel,
                    // @ts-expect-error - Property 'cpId' does not exist on type 'string'.ts(2339)
                    cpId: (_c = (_b = institutionLogin.aggregators.get(0)) === null || _b === void 0 ? void 0 : _b.channel) === null || _c === void 0 ? void 0 : _c.cpId,
                }],
        // todo: should we support clearing of brandingId and/or institutionId - (deactivation)
        // todo: what about setting of brandingId and/or institutionId - (activation)
        // todo: what about changing of brandingId and/or institutionId - (i.e. deactivation - reactivation)
    });
};
exports.transformInstitutionLoginToRequestData = transformInstitutionLoginToRequestData;
const transformRefreshingLoginsToRequestData = (logins, credentialsBlobsForRefreshingLogins, credentialsForRefreshingLogins) => {
    var _a, _b;
    const loginRefreshCredentials = [];
    if (credentialsBlobsForRefreshingLogins.size > 0) {
        credentialsBlobsForRefreshingLogins.forEach((credentialsBlob, institutionLoginId) => {
            if (logins.find((login) => login.id === institutionLoginId)) {
                loginRefreshCredentials.push({
                    institutionLoginId,
                    credentialsBlob,
                });
            }
        });
    }
    if (credentialsForRefreshingLogins.size > 0) {
        credentialsForRefreshingLogins.forEach((credentials, institutionLoginId) => {
            if (logins.find((login) => login.id === institutionLoginId)) {
                const tCredentials = credentials.toArray().map((credential) => ({ name: credential.key, key: credential.key, value: credential.value }));
                loginRefreshCredentials.push({
                    institutionLoginId,
                    credentials: tCredentials,
                });
            }
        });
    }
    return Object.assign(Object.assign(Object.assign({}, (((_a = feature_flags_1.featureFlagsSelectors.dangerouslyUseFeatureFlags()) === null || _a === void 0 ? void 0 : _a.get('ignoreRefreshThrottle'))
        && { doIgnoreThrottle: true })), { loginRefreshCredentials: loginRefreshCredentials.length > 0 ? loginRefreshCredentials : null }), (((_b = feature_flags_1.featureFlagsSelectors.dangerouslyUseFeatureFlags()) === null || _b === void 0 ? void 0 : _b.get('investmentTransactions'))
        && { investmentAggregationType: 'FULL_AGGREGATION' }));
};
exports.transformRefreshingLoginsToRequestData = transformRefreshingLoginsToRequestData;
const transformMfaResponseToMfaChallenge = (institutionLoginId, mfaResponse, submitUrl) => (types.mkMfaChallenge({
    institutionLoginId,
    challenges: (0, immutable_1.List)(mfaResponse.map((challenge) => {
        if (challenge.type === 'IMAGE') {
            return types.mkMfaChallengeItem({
                key: challenge.key,
                sequence: challenge.sequence,
                question: challenge.displayText,
                base64Image: challenge.image,
                answerChoices: !challenge.answerChoices ? null :
                    (0, immutable_1.List)(challenge.answerChoices.map((answerChoice) => (types.mkMfaAnswerChoice({
                        displayText: answerChoice.displayText,
                    })))),
            });
        }
        return types.mkMfaChallengeItem({
            key: challenge.key,
            sequence: challenge.sequence,
            question: challenge.question,
            answerChoices: !challenge.answerChoices ? null :
                (0, immutable_1.List)(challenge.answerChoices.map((answerChoice) => (types.mkMfaAnswerChoice({
                    displayText: answerChoice.displayText,
                })))),
        });
    })),
    submitUrl,
}));
exports.transformMfaResponseToMfaChallenge = transformMfaResponseToMfaChallenge;
const transformActionParamsToRequestData = (action, params) => {
    if (action === 'disconnect') {
        const data = {};
        // @ts-expect-error - Property 'doSynchrounous' does not exist on type '{}'.ts(2339)
        data.doSynchrounous = !!(params && params.doSynchrounous);
        return data;
    }
    return null;
};
exports.transformActionParamsToRequestData = transformActionParamsToRequestData;
// /////////////////////////////////////////////////////////////////////////////
// Transformers for Refresh Statusus
// /////////////////////////////////////////////////////////////////////////////
function transformResponseToRefreshStatus(response) {
    return types.makeRefreshResponse({
        jobId: response.jobId,
        isProcessing: response.isProcessing,
        status: response.status,
        institutionLogins: (0, immutable_1.List)(response.institutionLogins.map((login) => types.makeRefreshInstitutionLogin({
            id: login.id,
            isProcessing: login.isProcessing,
            status: login.status,
            credentialsBlob: login.credentialsBlob,
            submitUrl: login.pollingReference,
            aggregators: !login.aggregators ? null : (0, immutable_1.List)(login.aggregators.map((aggregator) => types.makeRefreshAggregator({
                channel: aggregator.channel,
                isProcessing: aggregator.isProcessing,
                aggStatus: aggregator.aggStatus,
                cpAggStatus: aggregator.cpAggStatus,
                cpAggStatusDetail: aggregator.cpAggStatusDetail,
                mfaChallenges: aggregator.mfaChallenges,
            }))),
        }))),
    });
}
exports.transformResponseToRefreshStatus = transformResponseToRefreshStatus;
